import { render, staticRenderFns } from "./ClassesByCoursesAndDepartmentBarChart.vue?vue&type=template&id=6d70ce88&"
import script from "./ClassesByCoursesAndDepartmentBarChart.vue?vue&type=script&lang=js&"
export * from "./ClassesByCoursesAndDepartmentBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports